export default __webpack_public_path__ + "static/media/screen6.aa2a9729.png";